import { render } from "./Bannar.vue?vue&type=template&id=11ee1af6&scoped=true"
import script from "./Bannar.vue?vue&type=script&lang=js"
export * from "./Bannar.vue?vue&type=script&lang=js"

import "./Bannar.vue?vue&type=style&index=0&id=11ee1af6&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ee1af6"]])

export default __exports__